import { Box, Paper, Typography, Button, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTheme, alpha } from "@mui/material/styles";
import BadgeIcon from "@mui/icons-material/Badge";
import CertificatesTable from "../certificatesTable";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function CertificatesTab({
  userDetails,
  certificates,
  sessionId,
  onLoadCertificate,
  handleApiError,
  setToast,
  onCertificateDelete,
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Grid container spacing={{ xs: 3, md: 4 }}>
      <Grid size={12}>
        <Paper
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BadgeIcon />
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {t("userProfile.certificatesTitle")}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {t(
                    "userProfile.certificatesDescription",
                    "Manage your professional certificates and qualifications"
                  )}
                </Typography>
              </Box>
            </Box>
            <Button
              startIcon={<BadgeIcon />}
              variant="contained"
              onClick={onLoadCertificate}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1.5,
                boxShadow: theme.shadows[2],
                "&:hover": {
                  boxShadow: theme.shadows[4],
                },
              }}
            >
              {t("userProfile.addCertificateButton")}
            </Button>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <CertificatesTable
            userName={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`.trim()}
            certificates={certificates || []}
            userId={sessionId}
            handleApiError={handleApiError}
            setToast={setToast}
            onCertificateDelete={onCertificateDelete}
            isOwnProfile={true}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}

CertificatesTab.propTypes = {
  userDetails: PropTypes.object,
  certificates: PropTypes.array,
  sessionId: PropTypes.string,
  onLoadCertificate: PropTypes.func.isRequired,
  handleApiError: PropTypes.func.isRequired,
  setToast: PropTypes.func.isRequired,
  onCertificateDelete: PropTypes.func.isRequired,
};

export default CertificatesTab;
